<div class="container-fluid service-bg">
    <div class="row">
        <div class="col-md-12 from-top">
            <!-- Welcome Message -->
            <h1 class="text-center text-style">{{'gen_welcome' | translate}} </h1>

            <!-- Login Form -->
            <div class="form-group login-form" [formGroup]="loginGroup">
                <mat-form-field class="form-element" appearance="fill" (keydown)="$event.keyCode == 13 ? login(): null">
                    <mat-label>{{'gen_user_name' | translate}}</mat-label>
                    <input [type]="'email'" matInput placeholder="{{'gen_user_name' | translate}}"
                        formControlName="email" required>

                    <!-- Errors -->
                    <mat-error *ngIf="loginGroup.controls.email.errors?.required">{{'error_required_error' | translate}}
                    </mat-error>
                    <mat-error *ngIf="loginGroup.controls.email.errors?.pattern">{{'error_email_invalid' | translate}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="form-element pb-0" appearance="fill"
                    (keydown)="$event.keyCode == 13 ? login(): null">
                    <mat-label>{{'gen_password' | translate}}</mat-label>
                    <input [type]="hide ? 'password' : 'text'" matInput placeholder="{{'gen_password' | translate}}"
                        formControlName="password" required>
                    <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>

                    <!-- Errors -->
                    <mat-error *ngIf="loginGroup.controls.password.errors?.required">{{'error_required_error' |
                        translate}}</mat-error>
                </mat-form-field>

                <!-- Forgot Password -->
                <p class="cursor-po-c" data-toggle="modal" data-target="#forgotPwdModal">
                    {{'gen_forgot_pwd' | translate}}
                </p>

                <button class="button w-100" (click)="login()" [disabled]="loginGroup.status == 'INVALID'">
                    <i class="pr-1 fa fa-sign-in-alt"></i>
                    {{'gen_login' | translate}}
                </button>

                <!-- Guest Login -->
                <span class="cursor-po-c" (click)="loginGuest()" *ngIf="features.hasGuest">
                    {{'gen_guest_login' | translate}}
                </span>

                <!-- Register -->
                <p class="pt-3">
                    {{'lf_register_msg' | translate}}
                    <a class="pl-2 clr-theme" href="#/register">{{'lf_register_btn' | translate}}</a>
                </p>
            </div>
        </div>
    </div>
</div>

<!-- Forgot Password Modal -->
<div class="modal" id="forgotPwdModal">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-sec">
            <div class="modal-header">
                <h4 class="modal-title">{{'gen_forgot_pwd' | translate}}</h4>
                <button type="button" class="close clr-pri-text cursor-po-c" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body" [formGroup]="forgotGroup">
                <mat-form-field class="form-element" appearance="fill">
                    <mat-label>{{'gen_email' | translate}}</mat-label>
                    <input [type]="'email'" matInput placeholder="{{'gen_email' | translate}}" formControlName="email"
                        required>

                    <!-- Errors -->
                    <mat-error *ngIf="forgotGroup.controls.email.errors?.required">{{'error_required_error' |
                        translate}}
                    </mat-error>
                    <mat-error *ngIf="forgotGroup.controls.email.errors?.pattern">{{'error_email_invalid' | translate}}
                    </mat-error>
                </mat-form-field>

                <button class="button w-100" (click)="forgotPassword()" data-dismiss="modal"
                    [disabled]="forgotGroup.status == 'INVALID'">{{'lf_forgot_pwd_sent_mail' | translate}}</button>
            </div>
        </div>
    </div>
</div>